import {QuickActions} from "../enums/quick-actions.enum";

export const QUICK_ACTION_BUTTON_USER_PERMISSION_LIST = [
  QuickActions.CREATE_CUSTOMER_PAYMENT,
  QuickActions.CREATE_CUSTOMER_PAYMENT_TEMPLATE,
  QuickActions.CREATE_FX_PAYMENT,
  QuickActions.CREATE_REQUEST_FOR_PAYMENT,
  QuickActions.CREATE_REQUEST_FOR_PAYMENT_TEMPLATE,

]


export const QUICK_ACTION_BUTTON_DEFAULT_LIST = [
  QuickActions.CREATE_PAYMENT,
  QuickActions.SEARCH_PAYMENT,
  QuickActions.RECENT_SEARCH,
]
